import { forwardRef, useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'; // basic styles (you can override)
import './CustomDatePicker.css';
import { DateUtil } from '../utils/DateUtil';
import { fr } from 'date-fns/locale';
import { registerLocale } from 'react-datepicker';

registerLocale('fr', fr);

interface CustomDatePickerProps {
  selectedDate: Date | null;
  onDateSelected: (date: Date | null) => void;
}

interface DatePickerInputProps {
  value?: string;
  onClick?: () => void;
  className?: string;
}

export function CustomDatePicker({selectedDate, onDateSelected}: CustomDatePickerProps) {
  const [startDate, setStartDate] = useState<Date | null>(selectedDate);

  useEffect(() => {
    //console.log("CustomDatePicker selectedDate props changed to: ", selectedDate);
    setStartDate(selectedDate);
  }, [selectedDate]);

  const DatePickerInput = forwardRef<HTMLButtonElement, DatePickerInputProps>(
    ({ value, onClick, className }, ref) => (
      <button type="button" className={className} onClick={onClick} ref={ref}>
        {value || 'Choisir une date'}
        {startDate && <span className="pill-check-badge" aria-hidden="true">✓</span>}
      </button>
    )
  );

  return (
    <DatePicker
      selected={startDate}
      onChange={(date) => { setStartDate(date); onDateSelected(date); }}
      customInput={<DatePickerInput value={DateUtil.formatDateToLocalYMD(startDate)} className="datepicker-input" />}
      className={["custom-datepicker", startDate ? "selected" : ""].join(' ')}
      locale="fr"
      dateFormat="d MMMM yyyy" // ⬅️ this will give 3 janvier 2025
      popperPlacement="bottom-start"
      renderCustomHeader={({
        date,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled
      }) => (
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
          <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} type="button" className="react-datepicker__navigation react-datepicker__navigation--previous" aria-label="Previous Month">
            <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous">Previous Month</span>
          </button>
          <span style={{ margin: '0 10px' }}>
            {DateUtil.getFrenchMonthName((date.getMonth() + 1).toString())} {date.getFullYear()}
          </span>
          <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} type="button" className="react-datepicker__navigation react-datepicker__navigation--next" aria-label="Next Month">
            <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next">Next Month</span>
          </button>
        </div>
      )}
      
    />
  );
}
